import { Box, Flex, Image } from "@chakra-ui/react";
import React from "react";
import { ManagerLabelProps } from "./ManagerLabel.types";

const ManagerLabel: React.FC<ManagerLabelProps> = ({ manager, ...rest }) => {
  if (!manager) return <></>;
  const imgUrl = manager.imgUrl;

  return (
    <Flex alignItems={"center"} {...rest}>
      <Flex
        alignItems={"center"}
        h={"35px"}
        w={"35px"}
        flex={"0 0 35px"}
        objectFit={"contain"}
        bg={"bg.grey"}
        overflow={"hidden"}
        borderRadius={3}
        mr={2}
        border={"1px solid"}
        borderColor={"border.grey"}
      >
        {imgUrl && <Image src={imgUrl} />}
      </Flex>
      <Box>{manager.name}</Box>
    </Flex>
  );
};

export default ManagerLabel;
